import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { DialogService } from '../../dialog/dialog.service';
import { SettingService } from '../../setting/setting.service';
import { dateAsString, dayAsString } from '../../shared/date.helper';
import { Inspection } from '../../shared/interfaces';
import { permissions } from '../../shared/permissions';
import { UserService } from '../../user/user.service';
import { InspectionService } from '../inspection.service';
import { InspectionStatus } from '../inspection.status';

@Component({
  selector: 'app-inspection-rejected',
  templateUrl: './inspection-rejected.component.html',
  styleUrls: ['./inspection-rejected.component.scss'],
})
export class InspectionRejectedComponent implements OnInit {
  inspections: Inspection[] = null;

  page = 1;
  pageSize = 10;
  count = 0;
  search = '';

  canEdit = false;

  url = 'inspection';
  loading = true;
  canAdd = false;
  loadDebounced = new Subject();

  actions = {
    list: [
      {
        label: 'Review',
        callback: (Inspection: Inspection) => async () => {
          console.log('Review', Inspection.id);
          return this.Review(Inspection.id);
        },
        show: item => () => {
          return this.canReview;
        },
      },
      {
        label: 'Send Reminder',
        callback: (Inspection: Inspection) => async () => {
          return this.sendReminderRejected(Inspection.id);
        },
        show: item => () => {
          return this.canRemind;
        },
      },
    ],
  };

  column = [
    { field: 'customerName', header: 'Customer', type: 'text', orderBy: 'customer.name' },
    { field: 'address', header: 'Location Address', type: 'text', orderBy: 'inspection.address' },
    { field: 'city', header: 'City', type: 'text', orderBy: 'inspection.city' },
    { field: 'state', header: 'State', type: 'text', orderBy: 'inspection.state' },
    { field: 'purpose', header: 'Purpose', type: 'text', orderBy: 'inspection.purpose' },
    { field: 'policyNumber', header: 'Policy No.', type: 'text', orderBy: 'policy.number' },
    { field: 'vendor.name', header: 'Vendor', type: 'text', orderBy: 'vendor.firstName' },
    { field: 'inspector.name', header: 'Inspector', type: 'text', orderBy: 'inspector.firstName' },
    { field: 'lastSynced', header: 'Last Synced', type: 'date', orderBy: 'inspection.lastSynced' },
    { field: 'completed', header: 'Completed', type: 'date', orderBy: 'inspection.completed' },
    { field: 'rejected', header: 'Rejected', type: 'date', orderBy: 'inspection.rejected' },
  ];

  canReview = false;
  canRemind = false;

  sendRemindersToInspectors = false;

  dateAsString = dateAsString;

  constructor(
    public inspectionService: InspectionService,
    public userService: UserService,
    private toastr: ToastrService,
    private settingService: SettingService,
    private dialog: DialogService,
    private router: Router,
  ) {}

  async ngOnInit() {
    // Debounce data loading
    this.loadDebounced
      .pipe(
        debounceTime(500),
        switchMap(params => this.loadDataLive(params)),
      )
      .subscribe();

    this.canAdd = await this.userService.hasPermissions([permissions.INSPECTION.CREATE]);
    this.canReview = await this.userService.hasPermissions([permissions.INSPECTION.REVIEW]);
    this.canRemind = await this.userService.hasPermissions([permissions.INSPECTION.SEND_REMINDERS]);

    this.sendRemindersToInspectors = await this.settingService.sendRemindersDirectlyToInspectors();
  }

  loadData(params) {
    console.log('loadData', params);
    this.loadDebounced.next(params);
  }

  async loadDataLive(params) {
    console.log('loadDataLive');
    let rows: any[];

    [rows, this.count] = await this.inspectionService.list({ ...params, ...{ status: InspectionStatus.REJECTED } });

    this.inspections = rows.map(i => ({
      ...i,
      day: i.dueDate ? dayAsString(new Date(i.dueDate)) : '',
    }));
    this.loading = false;
  }

  async sendReminderRejected(id: number) {
    if (this.sendRemindersToInspectors) {
      this.dialog.confirm().show({
        message: 'Send reminder to Inspector?',
        confirmed: async () => {
          await this.inspectionService.sendReminderToInspectorRejected(id);
          this.toastr.success('Reminder has been sent!');
        },
      });
    } else {
      this.dialog.confirm().show({
        message: 'Send reminder to Vendor?',
        confirmed: async () => {
          await this.inspectionService.sendReminderVendorRejected(id);
          this.toastr.success('Reminder has been sent!');
        },
      });
    }
  }

  Review(id: number) {
    this.router.navigateByUrl(`/inspection/review/main/${id}`);
  }

  open(ev, id: number) {
    if (ev.target.tagName === 'TD') {
      this.router.navigateByUrl(`/inspection/form/${id}`);
    }
  }
}
